import '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';

const _excluded = ["ref"];
const ClearIndicator = props => {
  const {
      children = /*#__PURE__*/createElement(Icon, {
        size: 24,
        glyph: icons.CLOSE
      }),
      getStyles,
      innerProps: {
        ref
      }
    } = props,
    restInnerProps = _objectWithoutProperties(props.innerProps, _excluded);
  return /*#__PURE__*/createElement("div", _extends({}, restInnerProps, {
    ref: ref,
    style: getStyles('clearIndicator', props)
  }), children);
};

export default ClearIndicator;
